import { render } from "./OrderSourceCreatePage.vue?vue&type=template&id=be9b98e8"
import script from "./OrderSourceCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderSourceCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__